import { render, staticRenderFns } from "./DayDetailComponent.vue?vue&type=template&id=371f8f30&"
import script from "./DayDetailComponent.vue?vue&type=script&lang=js&"
export * from "./DayDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports